var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticStyle:{"text-align":"left"}},_vm._l((_vm.data),function(it,index){return _c('li',{key:index},[_vm._v("\n    "+_vm._s(it)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }